import React from 'react'
import { STATICS } from 'statics'
import './style.scss'

export function InfoCard({ actions, children, title }) {
  function renderIcon(icon) {
    if (!icon) return null
    return <span className='icon'>{icon}</span>
  }

  function renderButtons() {
    return actions.map(({ icon, label, onClick }) => (
      <button className='button' type='button' key={label} onClick={onClick}>
        {renderIcon(icon)}
        {label}
        <span className='chevron'>
          <STATICS.ARROW_CARD_BUTTON />
        </span>
      </button>
    ))
  }

  return (
    <div className='info-card'>
      <div className='title-and-body'>
        <h3 className='title'>{title}</h3>
        {children}
      </div>
      <div className='action-buttons'>{renderButtons()}</div>
    </div>
  )
}
